// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'star';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m9.547.9 2.51 4.972 4.83.478a.604.604 0 0 1 .374 1.03l-3.975 3.94 1.474 5.354a.61.61 0 0 1-.863.701L9 14.95l-4.89 2.422a.61.61 0 0 1-.863-.701l1.473-5.354-3.978-3.94a.604.604 0 0 1 .375-1.03l4.83-.478L8.453.9a.614.614 0 0 1 1.094 0z'
  />
);

export const viewBox = '0 0 18 18';
